import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";

const SFSquareCheckbox = (props: CheckboxProps) => {
  return (
    <Checkbox
      {...props}
      checkedIcon={
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_113_5080)">
            <rect width="16" height="16" rx="4" fill="#A19BFD" />
            <path
              d="M5 8L7.5 11L12 5"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_113_5080">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      icon={
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_113_5086)">
            <rect
              x="1"
              y="1"
              width="14"
              height="14"
              rx="3"
              fill="white"
              stroke="#DFDFDF"
              strokeWidth="2"
            />
          </g>
          <defs>
            <clipPath id="clip0_113_5086">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
    />
  );
};

export default SFSquareCheckbox;
